import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { query } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import Link from '../../../../../../../src/components/common/link';
import KeyValueListView from '../../../../components/common/key-value-list-view';
import AbbreviatedGroup from '../../../../../../../src/components/common/abbreviated-group';

import ChartHeader from '../chart-header';
import PriceHistoryChartContainer from '../price-history-chart/price-history-chart-container';

import styles from './asset-position-details.styles';
import PaymentSelection from '../../../../../../../src/screens/payments/init-payments/payment-selection/index.js';
import Button from '@dbk/ui-buttons';
import TradeDetails from './trading-assets/trade-details';
import getDetailFields from './trading-assets/asset-position-details-field-mapping';

import TradePriceHistoryChart from '../asset-position-details/trading-assets/trade-asset-price-history-chart';
import { ASSETS, ENTITLEMENT, CTA, BUTTONTYPE } from '../asset-position-details/trading-assets/constants';
import TradeCTAButton from './trading-assets/trade-cta-button';

class AssetPositionDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedInteractionValue: null,
      seeTransactionsButtonLoading: false
    };

    this.moveToTransaction = this.moveToTransaction.bind(this);
  }

  handleInteractionChange = value => {
    this.setState({
      selectedInteractionValue: value,
    });
  }
  isPaymentAllowed(psPosId, paymentAvailableList) {
    const selectedDbtAcc = paymentAvailableList.find(x => x.psPosId == psPosId);
    if (selectedDbtAcc) {
      return true;
    }
    return false;


  }
  moveToTransaction() {
    this.setState({
      seeTransactionsButtonLoading: true,
    });
    const {
      assetCategory,
      positionType,
      changePage,
      row = {},
    } = this.props;
    const { id } = row;
    const linkValues = [assetCategory];
    if (positionType) {
      linkValues.push(positionType);
    }
    linkValues.push(id);


    const link = "/portfolios/" + linkValues.join('/');
    const positionIndex = row.index;
    this.props.moveToTransactionPage(assetCategory, positionIndex, link);
    // this.props.changePage({ pathname: link });
  }

  // function to get the trade asset position details
  getAssetPositionDetailsForTrading(props) {

    const { selectedPortfolio, row, messages, isVascoActivated } = props;

    const { enabled, tradable } = row;

    const isTradeRestricted = this.props.tradeSecurity && this.props.tradeSecurity.security &&
      this.props.tradeSecurity.security.restricted;

    // user portfolio entitlement(P4) check
    const showHideTradeableButton = selectedPortfolio.isTradingAvailable;

    const enableDisableTradeableButton = !isTradeRestricted &&
      (enabled === ENTITLEMENT.YES) &&
      (tradable === ENTITLEMENT.YES);
    // these flags are used for entitlement check

    return (
      <div className="security_detail_root trade-page security-list-item">
        <div className="security_detail">
          <div className="columns medium-6 small-12 chart_section" testID={"chart_position_entry_test"} accessibilityLabel={"chart_position_entry_test"}>
            <TradePriceHistoryChart
              row={row}
              messages={messages} />
          </div>

          <div className="columns medium-6 small-12" id="position-entry-asset-container" testID={"details_position_entry_test"} accessibilityLabel={"details_position_entry_test"}>
            <TradeDetails data={getDetailFields(row, messages, this.props.tradeSecurity && this.props.tradeSecurity.security, props.langCode)}
              messages={messages} />
            {isTradeRestricted &&
              <div className="position-entry-error">
                <span>{messages["app.trade.label.restrictedTrade"]}</span>
              </div>
            }
          </div>
        </div>
        <div className="position-entry-asset-cta">
          {row.id && <TradeCTAButton handleClick={this.moveToTransaction} fetchInProgress={this.props.showSpinner} value={BUTTONTYPE.SEETRANSACTIONS} className="positon-cta-buttons"
            message={messages["app.trade.label.cta.seeTransactions"]}
            tertiary />
          }
          {
            showHideTradeableButton && isVascoActivated &&
            <TradeCTAButton handleClick={() => this.props.handleCtaClick(CTA.SELL, row)} value={BUTTONTYPE.SELL} className="positon-cta-buttons"
              message={messages["app.trade.label.cta.sell"]} disabled={!enableDisableTradeableButton} />
          }
          {
            showHideTradeableButton && isVascoActivated &&
            <TradeCTAButton handleClick={() => this.props.handleCtaClick(CTA.BUY, row)} value={BUTTONTYPE.BUY} className="positon-cta-buttons"
              disabled={!enableDisableTradeableButton} message={messages["app.trade.label.cta.buy"]} />
          }
        </div>
      </div>
    )
  }

  // function to get the asset position details
  getAssetPositionDetails(props) {

    const {
      chartHeaderComponent,
      landscapeComponent,
      row = {},
      assetGroupId,
      assetShortDesc,
      detailsGroups = [],
      headerGroup,
      assetCategory,
      positionType,
      abbreviationRules,
      referenceCurrency,
      renderBottomSeparator = false,
      screen,
      subAssetdetailsGroups,
      messages,
      isPaymentAvailable,
      paymentAvailableList,
      subAssetsDesc,
      isVascoActivated
    } = props;
    const { selectedInteractionValue, seeTransactionsButtonLoading } = this.state;

    const {
      id,
      positionCurrency,
      dayChange,
      dayChangePercentage,
      chartHeaderValue,
      chartHeaderValueUnit,
      proportion,
      isin,
      priceDate,
      valueMovement,
    } = row;
    // const hasChartHeader =  ChartHeaderComponent && (assetShortDesc !== 'cash') ? true : false;
    const hasChartHeader = ChartHeaderComponent !== null;
    row.accruedInterestUnit = referenceCurrency;

    const ChartHeaderComponent = chartHeaderComponent;
    const LandscapeComponent = landscapeComponent;
    const mmDepositesPriceHistory = (assetShortDesc !== 'mmDeposites');
    const linkValues = [assetCategory];
    if (positionType) {
      linkValues.push(positionType);
    }
    linkValues.push(id);
    return (


      <View style={styles.root} testID="expandable-item">
        {hasChartHeader &&
          <ChartHeaderComponent
            dayChange={dayChange}
            dayChangePercentage={dayChangePercentage}
            value={chartHeaderValue}
            valueUnit={chartHeaderValueUnit}
            priceDateValue={priceDate}
            assetCategory={assetCategory}
            assetGroupId={row.assetGroupId}
            assetShortDesc={row.assetShortDesc}
            messages={messages}
          />
        }
        <KeyValueListView
          row={row}
          subAssetdetailsGroups={subAssetdetailsGroups}
          assetGroupId={row.assetGroupId}
          assetShortDesc={row.assetShortDesc}
          assetCategory={assetCategory}
          renderFirstSeparator={hasChartHeader}
          screen={screen}
          messages={messages}
        />

        <View style={styles.graphDisplay} testID="graph" >
          <PriceHistoryChartContainer
            row={row}
            currency={positionCurrency}
            height={250}
            width={600}
            selectedInteractionValue={selectedInteractionValue}
            onInteractionChange={this.handleInteractionChange}
            screen={screen}
            yValue={row.assetShortDesc}
            messages={messages}
          />
        </View>

        {id && row.subAssetsDesc === ASSETS.CASH && isPaymentAvailable && isVascoActivated && this.isPaymentAllowed(row.secID, paymentAvailableList) ?
          <View style={styles.footerRow}>
            <View style={styles.flexRow}>
              <Button tabIndex={0} testID="btn_assetList_assetPositionDetails_test" tertiary loading={seeTransactionsButtonLoading} onPress={this.moveToTransaction}>{messages['app.portfolio.assetDetails.seeTrans']}</Button>
              <View style={{ 'cursor': 'pointer' }}>
                <PaymentSelection pageName="position-page" psPosId={row.secID} />
              </View>
            </View>
          </View>
          :
          <View style={styles.seeTransactionsView}>
            {id &&
              <Button
                testID="btn_assetList_assetPositionDetails_test"
                tertiary
                loading={seeTransactionsButtonLoading}
                onPress={this.moveToTransaction}>
                {messages['app.portfolio.assetDetails.seeTrans']}
              </Button>
            }
          </View>
        }

      </View>)
  }
  render() {
    // this code will be removed
    // const {
    //   chartHeaderComponent,
    //   landscapeComponent,
    //   row = {},
    //   assetGroupId,
    //   assetShortDesc,
    //   detailsGroups = [],
    //   headerGroup,
    //   assetCategory,
    //   positionType,
    //   abbreviationRules,
    //   referenceCurrency,
    //   renderBottomSeparator = false,
    //   screen,
    //   subAssetdetailsGroups,
    //   messages,
    //   isPaymentAvailable,
    //   paymentAvailableList,
    //   subAssetsDesc,
    //   isVascoActivated
    // } = this.props;

    // const { selectedInteractionValue, seeTransactionsButtonLoading } = this.state;

    // const {
    //   id,
    //   positionCurrency,
    //   dayChange,
    //   dayChangePercentage,
    //   chartHeaderValue,
    //   chartHeaderValueUnit,
    //   proportion,
    //   isin,
    //   priceDate,
    //   valueMovement,
    // } = row;

    // const hasChartHeader =  ChartHeaderComponent && (assetShortDesc !== 'cash') ? true : false;
    // const hasChartHeader = ChartHeaderComponent !== null;
    // row.accruedInterestUnit = referenceCurrency;
    // const ChartHeaderComponent = chartHeaderComponent;
    // const LandscapeComponent = landscapeComponent;
    // const mmDepositesPriceHistory = (assetShortDesc !== 'mmDeposites');
    // const linkValues = [assetCategory];
    // if (positionType) {
    //   linkValues.push(positionType);
    // }
    // linkValues.push(id);

    const tradingAssets = ['equity', 'bonds'];
    const isTradeAsset = tradingAssets.some((el) => (this.props.row.subAssetsDesc && this.props.row.subAssetsDesc.includes(el)));

    //  const isEquity = (this.props.row.subAssetsDesc === "equity");

    // const abbreviatedGroupComponent = (
    //   <AbbreviatedGroup
    //     data={{
    //       ...row,
    //       marketValueUnit: referenceCurrency,
    //       unrealisedGLUnit: referenceCurrency,
    //     }}
    //     dataDefinitions={headerGroup}
    //     abbreviationRules={abbreviationRules}
    //     renderTopSeparator={hasChartHeader}
    //     renderBottomSeparator={renderBottomSeparator}
    //     messages={messages}
    //   />
    // );
    return (
      <View>
        {isTradeAsset && this.props.entitledForTrading ? this.getAssetPositionDetailsForTrading(this.props) : this.getAssetPositionDetails(this.props)}
      </View>
    );
  }
}

AssetPositionDetails.defaultProps = {
  chartHeaderComponent: ChartHeader,
  abbreviationRules: {},
  headerGroup: [],
  screen: {
    isSmall: false,
  },
};

AssetPositionDetails.propTypes = {
  assetCategory: PropTypes.string.isRequired,
  positionType: PropTypes.string,
  referenceCurrency: PropTypes.string,
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isin: PropTypes.string,
    positionCurrency: PropTypes.string,
    dayChange: PropTypes.number,
    dayChangePercentage: PropTypes.number,
    chartHeaderValue: PropTypes.number,
    chartHeaderValueUnit: PropTypes.string,
    quantity: PropTypes.number,
    marketValue: PropTypes.number,
    unrealisedGL: PropTypes.number,
  }),
  detailsGroups: KeyValueListView.propTypes.detailsGroups,
  headerGroup: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  })),
  chartHeaderComponent: PropTypes.func,
  selectedChartInteractionValue: PropTypes.number,
  onChartInteractionChange: PropTypes.func,
  landscapeComponent: PropTypes.func,
  abbreviationRules: PropTypes.object,
  screen: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    isSmall: PropTypes.bool,
  }),
};

export default AssetPositionDetails;
